import type { MenuExtendedProps } from "config/menus";
import { useDeviceSize } from "hooks";
import { MenuLinkWithSubmenuDesktop } from "./MenuLinkWithSubmenuDesktop";
import { MenuLinkWithSubmenuMobile } from "./MenuLinkWithSubmenuMobile";

export const MenuLinkWithSubmenu = ({
  menuLink,
  submenu,
}: {
  submenu: MenuExtendedProps["subMenu"];
  menuLink: JSX.Element;
}) => {
  const { isDesktop } = useDeviceSize();

  return isDesktop ? (
    <MenuLinkWithSubmenuDesktop menulink={menuLink} submenu={submenu} />
  ) : (
    <MenuLinkWithSubmenuMobile menulink={menuLink} submenu={submenu} />
  );
};
